<template>
	<div class="feedB" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="feedItem" v-for="(item, index) in perData" :key="index" :class="{ active: flag }">
			<div class="feedH">
				<div class="feedTit">
					<div class="feedStatus" :class="{ feedStatus1: item.recoverContent ? true : false }">
						{{ item.recoverContent ? '已回复' : '未回复' }}
					</div>
					<h2>{{ item.title }}</h2>
					<p>{{ item.createTime | momentYR('YYYY年MM月DD日') }}</p>
				</div>
				<div class="feedIcon feedIcon1" @click="delBtn(item)">
					<span>删除</span>
				</div>
				<div class="feedIcon" @click="decBtn(item)">
					<span>查看</span>
					<i class="el-icon-arrow-right"></i>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'feedB',
	data() {
		return {
			flag: false,
			flags: false,
			perData: [],
			fullscreenLoading: false
		};
	},
	methods: {
		delBtn(item) {
			this.$confirm(`是否删除该记录?`, '提示', {
				confirmButtonText: '确认',
				confirmButtonClass: 'delBtns',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					let set = this.$loading(this.$pre);
					this.$http.delete(`api/app/yydApplyResources/${item.applyResourcesId}`).then((res) => {
						set.close();
						if (res.code == 200) {
							this.$message({
								type: 'success',
								message: '删除成功'
							});
							this.init();
						}
					});
				})
				.catch(() => {});
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get('api/app/yydApplyResources/list').then((res) => {
				this.fullscreenLoading = false;
				if (res.code == 200) {
					console.log(res, 8888);
					this.perData = res.rows || [];
				}
			});
		},
		decBtn(item) {
			this.$emit('hdFn', 'xuqiuSqC', item);
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.feedB {
	padding: 22px 21px;
	.feedItem {
		padding: 19px 26px 19px 10px;
		position: relative;
		box-sizing: border-box;
		background: #f9f9f9;
		border-radius: 10px;
		transition: 1s;
		margin-bottom: 10px;
		.feedH {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}
		.feedTit {
			display: flex;
			align-items: center;
			flex: 1;
			.feedStatus {
				width: 50px;
				height: 24px;
				line-height: 24px;
				text-align: center;
				color: #fff;
				background: #ff9d32;
				margin-right: 11px;
				border-radius: 6px;
				font-size: 12px;
			}
			.feedStatus1 {
				background: #17b939;
			}
			h2 {
				color: #000000;
				font-size: 16px;
				font-weight: bold;
			}
			p {
				font-size: 12px;
				color: #ababab;
				margin-left: 11px;
				margin-top: 4px;
			}
		}
		.feedIcon {
			display: flex;
			align-items: center;
			color: #ababab;
			font-size: 14px;
			cursor: pointer;
			justify-content: flex-end;
			i {
				margin-left: 6px;
			}
		}
		.feedIcon1 {
			margin-right: 10px;
			color: rgb(250, 74, 27);
		}
		.feedCont {
			background: #fff;
			margin-top: 17px;
			border-radius: 10px;
			padding: 0 9px;
			display: none;
			.feedContTop {
				padding: 15px 6px 20px;
				box-sizing: border-box;
				border-bottom: 1px dashed #efecec;
				color: #333333;
				font-size: 14px;
				line-height: 2;
				text-indent: 2em;
			}
			.feedContBot {
				.tit {
					margin: 11px 0 10px;
					color: #333333;
					font-weight: bold;
					padding-left: 9px;
				}
				p {
					color: #333333;
					font-size: 14px;
					line-height: 2;
					text-indent: 2em;
					padding: 0 15px;
				}
				.times {
					color: #8f9190;
					font-size: 12px;
					padding: 4px 15px 18px;
				}
			}
		}
	}
	.active {
		.feedIcon {
			span {
				color: #1d7b3a;
			}
		}
		.feedCont {
			display: block;
		}
	}
}
</style>
